const Mss = () => {
  return (
    <div className="mss">
      <h2>MOBİL ASSISTANCE SERVİS HİZMETLERİ DENETİM DANIŞMANLIK TİCARET LTD. ŞTİ.</h2>
      <h2>MESAFELİ HİZMET SATIŞ SÖZLEŞMESİ</h2>

      <h2>MADDE 1 – TARAFLAR</h2>
      <h3>1.1. HİZMET SAĞLAYICI</h3>
      <ul>
        <li>
          Unvanı: MOBİL ASSISTANCE Servis Hizmetleri Denetim Danışmanlık Ticaret Ltd. Şti. (İşbu
          sözleşmede &quot;HİZMET SAĞLAYICI&quot; olarak anılacaktır).
        </li>
        <li>
          Adres: GevherNesibe Mah. Alpay Sok. Lifos Tower 4/7-8 Kocasinan / Kayseri
        </li>
        <li>Çağrı Merkezi / Telefon: 0850 255 02 03</li>
        <li>
          E-Posta: info@mobilassistance.com | İnternet Sitesi: www.mobilassistance.com
        </li>
      </ul>
      <h3>1.2. MÜŞTERİ / TÜKETİCİ</h3>
      <p>
        www.mobilassistance.com internet sitesi, mobil kanallar veya 0850 255 02 03 numaralı çağrı
        merkezi üzerinden işbu sözleşmeye konu Yol Yardım ve İkame Araç Hizmet Paketleri’ni veya
        münferit çekici/yol yardım hizmetini elektronik ortamda onaylayarak satın alan gerçek veya
        tüzel kişidir (İşbu sözleşmede &quot;MÜŞTERİ&quot; olarak anılacaktır).
      </p>
      <p>
        HİZMET SAĞLAYICI ve MÜŞTERİ bundan böyle birlikte &quot;Taraflar&quot;, ayrı ayrı ise
        &quot;Taraf&quot; olarak anılacaktır.
      </p>

      <h2>MADDE 2 – SÖZLEŞMENİN KONUSU VE NİTELİĞİ</h2>
      <p>
        2.1. İşbu Sözleşme’nin konusu; MÜŞTERİ&apos;nin HİZMET SAĞLAYICI’ya ait
        www.mobilassistance.com internet sitesi, mobil arayüzler veya çağrı merkezi üzerinden satın
        aldığı, nitelikleri ve kapsamı işbu sözleşmede belirlenen süreli Yol Yardım, Çekme, Kurtarma,
        Nakil ve İkame Araç Hizmet Paketleri’nin (veya münferit acil çekici organizasyonlarının) satış
        ve ifa koşulları ile tarafların karşılıklı hak ve yükümlülüklerinin 6502 sayılı Tüketicinin
        Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri çerçevesinde
        düzenlenmesidir.
      </p>
      <h3>2.2. HİZMET ORGANİZASYONU NİTELİĞİ VE SİGORTA OLMAMA BEYANI</h3>
      <p>
        HİZMET SAĞLAYICI; anlaşmalı yetkili servis, bağımsız tamirhane, çekici, vinç/kurtarıcı
        operatörleri, rent a car (oto kiralama) ve benzeri üçüncü taraf profesyonel hizmet birimleri
        aracılığıyla yolda kalan araçlara acil yol yardım, çekme, kurtarma ve asistans organizasyonu
        sunan bir hizmet organizasyon ve asistans firmasıdır.
      </p>
      <p>
        HİZMET SAĞLAYICI kesinlikle bir sigorta şirketi veya sigorta aracısı değildir; 5684 sayılı
        Sigortacılık Kanunu anlamında sigortacılık faaliyeti yürütmez, risk teminatı üstlenmez ve
        MÜŞTERİ&apos;nin aracını sigortalamaz. İşbu sözleşme herhangi bir hasar tazminatı, değer
        kaybı karşılama veya sigorta poliçesi mahiyetinde olmayıp, münhasıran sözleşmede sınırları
        belirlenen limit ve olay adetleri dahilinde hizmet organizasyonunun koordinasyonunu kapsar.
      </p>

      <h2>MADDE 3 – GENEL KULLANIM ŞARTLARI, COĞRAFİ KAPSAM VE BEKLEME SÜRELERİ</h2>
      <p>
        3.1. Coğrafi Kapsam: Hizmetler, Türkiye Cumhuriyeti sınırları dahilinde (karayolu ile ulaşımı
        bulunmayan adalar hariç olmak üzere) 81 ilde, resmi karayolu vasfındaki yollarda 7 gün 24 saat
        geçerlidir.
      </p>
      <h3>3.2. Yürürlük ve Bekleme Süresi</h3>
      <ul>
        <li>
          İşbu sözleşme kapsamında satın alınan yıllık paketler, sözleşme tanzim tarihinden itibaren
          20 (yirmi) gün sonra yürürlüğe girer ve hizmet organizasyonu bu sürenin dolmasıyla aktif
          hale gelir.
        </li>
        <li>
          Yeni tescil edilen (noter tescil tarihi ile sözleşme tarihi aynı gün olan) araçlarda bekleme
          süresi 24 (yirmi dört) saattir.
        </li>
        <li>
          Sözleşme tanzim tarihinden ve bekleme süresinin bitiminden önce meydana gelmiş mevcut
          arıza, kaza, mekanik hasarlar veya devam eden olaylar paket kapsamı dışındadır.
        </li>
      </ul>
      <p>
        3.3. Olaylar Arası Asgari Süre: Aynı araç için arıza veya kaza nedeniyle ikinci bir
        çekme/kurtarma organizasyonunun sağlanabilmesi için, iki olay arasında en az 7 (yedi) takvim
        günü geçmiş olması zorunludur.
      </p>
      <p>
        3.4. Ruhsat ve Plaka Değişikliği: Paketler plaka ve ruhsat sahibi adına tanımlanır. Ruhsat
        sahibinin değişmesi halinde üyelik sona erer, hizmet başka araca veya şahsa devredilemez ve
        ücret iadesi talep edilemez. Aynı ruhsat sahibinin sadece plakasının değişmesi durumunda
        çağrı merkezine plaka güncellemesi yapılabilir.
      </p>

      <h2>MADDE 4 – PAKET TÜRLERİ VE HİZMET ORGANİZASYON LİMİTLERİ</h2>

      <h3>4.1. YOL YARDIM ELİT PAKETİ</h3>
      <ul>
        <li>Kapsama Giren Araçlar: Hususi kullanım binek otomobiller ve motosikletler.</li>
        <li>
          Kapsam Dışı Araçlar: Minibüs, panelvan, kamyonet, kamyon, traktör, otobüs, çekici, taksi,
          kiralık araç ve her türlü ticari araç.
        </li>
        <li>
          Çekme Organizasyonu: Arıza halinde yılda en fazla 2 (iki) kez, olay başına azami 5.000 TL
          (toplam 10.000 TL); Kaza halinde yılda en fazla 2 (iki) kez, olay başına azami 5.000 TL
          (toplam 10.000 TL) olmak üzere yıllık toplam azami 20.000 TL limit dahilinde en yakın oto
          tamir servisine nakil sağlanır.
        </li>
        <li>
          Kurtarma: Kaza sonucu devrilme veya şarampole düşme halinde yılda 1 kez azami 10.000 TL.
        </li>
      </ul>

      <h3>4.2. YOL YARDIM DİVAN PAKETİ</h3>
      <ul>
        <li>
          Kapsama Giren Araçlar: Otomobil, minibüs, panelvan, açık kasa kamyonet ve kiralık araç tipi
          hususi araçlar.
        </li>
        <li>
          Çekme Organizasyonu: Arıza halinde yılda en fazla 2 kez toplam azami 15.000 TL; Kaza
          halinde yılda en fazla 2 kez toplam azami 15.000 TL. Yıllık toplam çekme organizasyon tutarı
          30.000 TL ile sınırlıdır.
        </li>
        <li>Kurtarma: Yılda 1 kez azami 10.000 TL.</li>
      </ul>

      <h3>4.3. TAMAMLAYICI YOL YARDIM PAKETİ</h3>
      <ul>
        <li>
          Kapsama Giren Araçlar: Hususi binek araçlar ile toplu mal/yolcu taşımacılığında kullanılmayan
          hususi kamyonet, panelvan, back-up, açık kasa kamyonet ve minibüsler (9-15 koltuk).
        </li>
        <li>
          Çekme: Arıza halinde yılda 2 kez azami 15.000 TL; Kaza halinde yılda 2 kez olay başına azami
          15.000 TL (yıllık toplam 30.000 TL).
        </li>
        <li>
          İkametgâh İline Nakil: Kaza sonucu aracın yürüyemez hale gelmesi ve onarımının yerinde
          yapılamaması halinde; 300 km&apos;ye kadar aynı gün, 300 km üzerinde 1-7 iş günü içinde,
          ruhsat ve kaza tutanağının ibrazı şartıyla yılda 1 kez azami 25.000 TL&apos;ye kadar nakil
          organizasyonu sağlanır.
        </li>
      </ul>

      <h3>4.4. YOL YARDIM YETKİLİ SERVİS PAKETİ</h3>
      <ul>
        <li>
          Kapsama Giren Araçlar: Model yılı itibarıyla 15 (on beş) yaşını aşmamış hususi otomobil,
          kamyonet, minibüs, panelvan ve midibüsler (18-22 koltuk). 15 yaş üstü araçlar için hizmet
          verilmez; tespitinde sözleşme tek taraflı sona erdirilir.
        </li>
        <li>
          Çekme: Arıza halinde yılda 1 kez azami 10.000 TL; Kaza halinde yılda 1 kez azami 10.000 TL
          ile aynı il sınırları içinde en yakın yetkili servise veya sanayi bölgesine nakil sağlanır.
        </li>
        <li>Kurtarma: Yılda 1 kez azami 10.000 TL.</li>
      </ul>

      <h3>4.5. SINIRSIZ DÖRT DÖRTLÜK YOL YARDIM PAKETİ</h3>
      <ul>
        <li>
          Kapsama Giren Araçlar: Hususi binek araçlar ile kamyonet, minibüs, panelvan, midibüs (18-22
          koltuk) tipi araçlar (Taksi, kiralık araç ve ambulans hariçtir).
        </li>
        <li>
          Sınırsız Çekme Modeli: Arıza halinde yılda 2 kez; Kaza halinde yılda 2 kez il sınırları
          içerisinde en yakın yetkili servis veya sanayi bölgesine çekme sağlanır. İl sınırları içinde
          tutar limiti uygulanmaz.
        </li>
        <li>İkametgâh İline Nakil: Yılda 1 kez azami 25.000 TL.</li>
        <li>
          İkame Araç Organizasyonu: Yalnızca binek otomobil ve 4+1 kamyonetler için geçerlidir. Çift
          taraflı kazalarda aracın trafikte güvenle yürüyemeyeceğinin kaza tutanağı ve olay yeri
          fotoğraflarıyla belgelenmesi halinde azami 7 (yedi) gün B segment ikame araç sağlanır.
          Yüzeysel cam, ayna, kaporta hasarlarında ikame araç verilmez. Rent a car firmasının kiralama
          şartları (ehliyet süresi, kredi kartı depozitosu/blokesi) MÜŞTERİ tarafından karşılanır.
          Araç temin edilememesi halinde günlük azami 1.500 TL (KDV dahil) olmak üzere en fazla 7 gün
          ikame araç bedeli ödenir. Alkollü veya ehliyetsiz kullanımda ikame araç sağlanmaz.
        </li>
      </ul>

      <h3>4.6. AĞIR TİCARİ TAMAMLAYICI YOL YARDIM PAKETİ</h3>
      <ul>
        <li>
          Kapsama Giren Araçlar: 20 yaşını aşmamış ticari taksi, çekici, tır, dorse, kamyon, otobüs ve
          midibüsler (İnşaat ve iş makineleri hariçtir).
        </li>
        <li>
          Bekleme Süresi: Tanzim tarihinden 20 gün sonra; yeni tescilde 7 gün sonra yürürlüğe girer.
        </li>
        <li>
          Çekme: Arıza halinde yılda 2 kez azami 30.000 TL; Kaza halinde yılda 2 kez azami 30.000 TL
          (yıllık toplam 70.000 TL).
        </li>
        <li>Kurtarma: Yılda 1 kez azami 10.000 TL.</li>
        <li>İstisna: Lastik patlaması ve yakıt bitmesi bu paket kapsamında değildir.</li>
      </ul>

      <h3>4.7. LASTİK DEĞİŞİMİ VE YAKIT BİTMESİ DESTEĞİ</h3>
      <p>
        Elit, Yetkili Servis ve Sınırsız paketlerinde geçerlidir. Araçta sağlam yedek lastik bulunması
        şartıyla olay yerinde değişim yapılır; yedek lastik yoksa en yakın lastikçiye yılda 1 kez
        çekim sağlanır. Lastik malzeme/tamir bedeli MÜŞTERİ’ye aittir. Yakıt bitmesinde araç en yakın
        akaryakıt istasyonuna yılda 1 kez çekilir (akaryakıt bedeli MÜŞTERİ’ye aittir).
      </p>

      <h2>MADDE 5 – OPERASYONEL ESASLAR, HİZMETİN KULLANILMIŞ SAYILMASI VE BEKLEME (DEMURRAGE)</h2>
      <p>
        5.1. Hizmet Talep Usulü: MÜŞTERİ, hizmete ihtiyaç duyduğu anda 7/24 hizmet veren 0850 255 02
        03 numaralı çağrı merkezini aramak ve talep kaydı oluşturmak zorundadır. Çağrı merkezi
        aranmadan MÜŞTERİ’nin kendi inisiyatifiyle çağırdığı çekici veya servis bedelleri geriye
        dönük olarak kesinlikle ödenmez ve karşılanmaz.
      </p>
      <h3>5.2. Hizmet Birimini Beklememe / Hizmetin Kullanılmış Sayılması</h3>
      <ul>
        <li>
          HİZMET SAĞLAYICI tarafından yönlendirilen çekici/kurtarıcı operatörü yola çıktıktan sonra;
          MÜŞTERİ’nin haklı bir gerekçe olmaksızın beklemekten vazgeçmesi, olay yerini terk etmesi
          veya başka bir çekici ile anlaşıp ayrılması halinde, ilgili talep &quot;Kullanılmış
          Hizmet&quot; sayılır ve yıllık paket hakkından 1 (bir) adet düşülür.
        </li>
        <li>
          Paket limitini aşan veya münferit siparişlerde, çekici yola çıktıktan sonra yapılan haksız
          iptallerde fiilen oluşan operasyon ve akaryakıt maliyetini karşılamak üzere asgari boş
          çekiş bedeli tahakkuk ettirilir.
        </li>
      </ul>
      <p>
        5.3. Olay Yerinde Bekleme (Demurrage) Bedeli: Çekici olay yerine ulaştıktan sonra
        MÜŞTERİ&apos;den kaynaklanan nedenlerle (anahtar/ruhsat arama, polisin kaza tutanağını
        bekleme, araç içi yükün boşaltılması vb.) 15 (on beş) dakikayı aşan beklemelerde; ilk 15
        dakikadan sonraki her 15 dakika için 250 TL ek bekleme bedeli tahakkuk eder ve MÜŞTERİ bu
        bedeli çekici operatörüne veya HİZMET SAĞLAYICI&apos;ya ödemekle yükümlüdür.
      </p>
      <p>
        5.4. Yan ve Ek Giderler: Köprü, otoyol, feribot, tünel geçiş ücretleri, otopark bedelleri ve
        araç içindeki yük/bagajın indirilmesi masrafları hizmet organizasyon tutarına dahil olmayıp
        münhasıran MÜŞTERİ&apos;ye aittir.
      </p>

      <h2>MADDE 6 – KAPSAM DIŞI HALLER VE SORUMSUZLUK KAYITLARI</h2>
      <p>
        6.1. Mekanik Arıza Sayılmayan Durumlar: Sadece aracın güvenle ilerlemesine engel
        mekanik/elektriksel arıza ve kazalar kapsama dahildir. Çamura/kuma batma, kar zinciri
        takmama, cam kırılması, silecek çalışmaması, far yanmaması, yakıt donması gibi durumlar arıza
        kapsamında çekme hizmeti doğurmaz.
      </p>
      <p>
        6.2. Uygunsuz Güzergâh ve Kapalı Otopark: Çekici aracının fiziki ve can güvenliği açısından
        girmesi mümkün olmayan kapalı otoparklar, girilmesi yasak alanlar, bataklık veya orman
        arazilerinde hizmet verilmez.
      </p>
      <p>
        6.3. Taşıma Sırasındaki Zararlar: Yönlendirilen bağımsız çekici operatörü tarafından aracın
        yüklenmesi, bağlanması veya nakli esnasında meydana gelebilecek hasarlardan Türk Ticaret
        Kanunu’nun taşıma hükümleri gereğince doğrudan fiili taşımayı gerçekleştiren çekici
        operatörü sorumludur. HİZMET SAĞLAYICI taşıma esnasında doğan doğrudan veya dolaylı
        maddi/ticari hasarlardan ve değer kayıplarından sorumlu tutulamaz.
      </p>
      <p>
        6.4. Mücbir Sebepler: Doğal afet, aşırı kar/buzlanma, yol kapanması, grev, terör veya yetkili
        mercilerin operasyonu engellemesi hallerinde gecikmelerden HİZMET SAĞLAYICI sorumlu değildir.
      </p>

      <h2>MADDE 7 – CAYMA HAKKI, İPTAL VE İADE KOŞULLARI</h2>
      <p>
        7.1. Yasal Cayma Hakkı: MÜŞTERİ, işbu sözleşmenin kurulduğu tarihten itibaren 14 (on dört)
        gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden cayma
        hakkına sahiptir.
      </p>
      <p>
        7.2. Cayma Hakkının İstisnası (Hizmetin İfası): 6502 sayılı Kanun ve Mesafeli Sözleşmeler
        Yönetmeliği’nin 15/1-(h) maddesi uyarınca; 14 günlük yasal süre içerisinde MÜŞTERİ’nin onayı
        veya çağrı merkezi talebi ile yol yardım, çekici veya ikame araç hizmetinin ifasına başlanmış
        veya paket haklarından herhangi biri kullanılmış ise cayma hakkı kullanılamaz ve ücret iadesi
        yapılmaz.
      </p>
      <p>
        7.3. İade Usulü: Şartları taşıyan cayma taleplerinde tahsil edilen paket bedeli, cayma
        bildiriminin HİZMET SAĞLAYICI’ya ulaştığı tarihten itibaren en geç 14 (on dört) gün
        içerisinde MÜŞTERİ’nin ödeme yaptığı kanaldan (kredi kartına iade yoluyla) kesintisiz olarak
        iade edilir.
      </p>

      <h2>MADDE 8 – KİŞİSEL VERİLERİN KORUNMASI (KVKK)</h2>
      <p>
        MÜŞTERİ’ye ait kimlik, iletişim, plaka, araç arıza bilgisi ve anlık lokasyon (GPS) verileri;
        6698 sayılı Kişisel Verilerin Korunması Kanunu’nun 5/2-(c) maddesi uyarınca işbu sözleşmenin
        kurulması ve ifası amacıyla, çekici operatörünün olay yerine yönlendirilmesi için zorunlu olan
        ölçüde işlenmekte ve aktarılmaktadır. Detaylı bilgilendirmeye web sitesinde yayınlanan ve
        sözleşmenin ayrılmaz eki olan KVKK Aydınlatma Metni üzerinden her zaman erişilebilir.
      </p>

      <h2>MADDE 9 – DELİL SÖZLEŞMESİ (HMK m. 193)</h2>
      <p>
        Taraflar, işbu sözleşmeden doğabilecek her türlü uyuşmazlıkta; HİZMET SAĞLAYICI’nın ticari
        defter ve muhasebe kayıtları, 0850 255 02 03 numaralı çağrı merkezi ses kayıtları, web
        sitesi/sunucu erişim logları, çekici operatörüne ait GPS uydu takip kayıtları, SMS iletim
        raporları ve WhatsApp yazışma verilerinin Hukuk Muhakemeleri Kanunu’nun 193. maddesi
        anlamında geçerli, bağlayıcı, kesin ve münhasır delil teşkil edeceğini kabul ve beyan ederler.
      </p>

      <h2>MADDE 10 – UYGULANACAK HUKUK VE YETKİLİ YARGI MERCİİ</h2>
      <p>10.1. İşbu sözleşmeden doğan uyuşmazlıklarda Türk Hukuku uygulanır.</p>
      <p>
        10.2. Tüketici vasfını haiz MÜŞTERİ&apos;ler; Ticaret Bakanlığı’nca ilan edilen parasal
        sınırlar dahilinde kendi yerleşim yerindeki veya tüketici işleminin yapıldığı yerdeki
        Tüketici Hakem Heyetleri’ne veya Tüketici Mahkemeleri’ne başvurabilir.
      </p>
      <p>
        10.3. Tacir veya tüzel kişi MÜŞTERİ&apos;ler ile HİZMET SAĞLAYICI arasındaki ticari
        uyuşmazlıklarda ise HMK m. 17 uyarınca münhasıran KAYSERİ Merkez Mahkemeleri ve İcra
        Daireleri yetkilidir.
      </p>

      <h2>MADDE 11 – YÜRÜRLÜK</h2>
      <p>
        11 (on bir) maddeden ibaret işbu Sözleşme, MÜŞTERİ tarafından internet sitesi, mobil kanal
        veya çağrı merkezi üzerinden elektronik ortamda onaylandığı ve paket bedelinin tahsil
        edildiği tarihte yürürlüğe girer.
      </p>
      <p>
        HİZMET SAĞLAYICI: MOBİL ASSISTANCE SERVİS HİZMETLERİ DENETİM DANIŞMANLIK TİCARET LTD. ŞTİ.
      </p>
      <p>MÜŞTERİ: Web / Çağrı Merkezi Üzerinden Onaylayan Araç Sahibi</p>
    </div>
  )
}

export default Mss
